import { META } from './data';
export default function Footer({ setPage }) {
  return (
    <footer className="bg-[#1B2D8C] text-[#F0EBE0] mt-24">
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-14 grid md:grid-cols-[1.5fr_1fr_1fr] gap-10">
        <div>
          <p className="font-serif italic text-5xl text-[#FFC700]">{META.brand}</p>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#F0EBE0]/55 mt-2" dangerouslySetInnerHTML={{ __html: META.tag }} />
          <p className="font-sans text-sm text-[#F0EBE0]/55 mt-5 leading-[1.7] max-w-md">A six-person studio in Brooklyn working with one new client a quarter on identity systems & the digital products that carry them.</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FFC700] mb-3">Studio</p>
          <p className="font-sans text-sm text-[#F0EBE0]/85 leading-relaxed">68 Jay Street, Suite 412<br />Brooklyn, NY 11201<br />By appointment</p>
        </div>
        <div>
          <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#FFC700] mb-3">Engagements</p>
          <p className="font-sans text-sm text-[#F0EBE0]/85 leading-[1.65]">One new client a quarter.<br />Engagements run 5—14 months.<br />Investment from $180k.</p>
          <button onClick={() => setPage('brief')} className="mt-3 font-mono text-[10px] tracking-[0.32em] uppercase border-b border-[#FFC700] text-[#FFC700] hover:text-[#F0EBE0]">Send a brief →</button>
        </div>
      </div>
      <div className="border-t border-[#F0EBE0]/15 px-8 lg:px-14 py-5 max-w-[1500px] mx-auto flex flex-wrap items-center justify-between gap-4 font-mono text-[10px] tracking-[0.3em] uppercase text-[#F0EBE0]/40"><span>© 2026 {META.brand} · Brooklyn · No advertising</span><span>contact@vespera.studio</span></div>
    </footer>
  );
}
